import {Injectable} from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { catchError, Observable, throwError } from 'rxjs';
import { DataService } from 'src/app/services/data.service';


@Injectable()
export class UserSelectionService extends DataService {
  constructor(protected http: HttpClient) {
    super(http);
  }
  private baseURI = this.apiUri + '/';
  // private baseURI = '/tmssserver/api/';

  /**
   * getting user roles
   */


  getMultiUserRoles(): Observable<any> {
    this.setUri(this.baseURI + 'organizationuserrole/userassociations');
    return this.get();
  }

  /**
   * getting user roles
   */
  getMultiUserRolesWithEmail(email): any {
    return this.http.get(this.baseURI + 'organizationuserrole/userassociations/' + email);
  }

  /**
   * getting user roles
   */
  getSingleUserRolesWithUserIdAndOrgId(userId, orgId): any {
    return this.http.get(this.baseURI + 'organizationuserrole/userassociations/' + userId + '/organizationId/' + orgId);
  }

  /**
   * getting user roles
   */
  checkUserIsAdminWithEmailAndOrgId(email, orgId): any {
    return this.http.get(this.baseURI + 'organizationuserrole/userassociations/email/' + email + '/organizationId/' + orgId);
  }


  /**
   * saving user session
   */
  saveUSerRoleWithSession(payload): any {
    return this.http.post(this.baseURI + 'usersession/saveusersession', payload);
  }

  /**
   *  getting user session
   */
  getUserSession(jsessionId): any {
    return this.http.get(this.baseURI + 'usersession/getcurrentsession/' + jsessionId + '/jsessionid ');
  }

  /**
   * removing the user session
   */
  removeUserSession(userId, jsessionid): any {
    return this.http.put(this.baseURI + 'usersession/removeusersession/' + userId + '/userid/' + jsessionid + '/jsessionid', {});
  }

  /**
   * removing the user session using userId
   */
  removeUserSessionByUserId(userId: number): Observable<any> {
    const fullUrl = this.baseURI + `usersession/removeusersession/${userId}/userid`;
    // return this.http.put<any>(this.baseURI + 'usersession/removeusersession/' + userId + '/userid', {});
    return this.http.put(fullUrl, {})
    .pipe(
      catchError(error => {
        console.error('Error removing user session', error);
        return throwError(() => new Error('Failed to remove user session'));
      })
    );
  }

  /**
   *  getting user session
   */
  getJSession(): any {
    return this.http.get(this.baseURI + 'usersession/jsessionId');
  }

}

